import { z } from 'zod';

const backendErrorSchema = z.object({
  response: z.object({
    data: z.object({
      message: z.string(),
    }),
  }),
});

export const getErrorExtra = (rawError: unknown) => {
  const error = rawError instanceof Error ? rawError : undefined;
  const parsedBackendError = backendErrorSchema.safeParse(rawError).data;

  return {
    rawError,
    error,
    parsedBackendError,
  };
};

export const getErrorMessage = (error: unknown): string | null => {
  const extra = getErrorExtra(error);

  if (extra.parsedBackendError) {
    return extra.parsedBackendError.response.data.message;
  }

  if (extra.error) {
    return extra.error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return null;
};
